import axios from 'axios';
import { store } from '../redux/store';
import { logout } from '../redux/AuthReducer/action';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const statusCode = error?.response?.data?.statusCode || error?.response?.status;

        if (statusCode === 401) {
            store.dispatch(logout);
            window.location.href = '/?session_expired=true';
            sessionStorage.clear();
        }

        return Promise.reject(error);
    }
);

// Global request interceptor to trim leading/trailing spaces from query parameters
axios.interceptors.request.use((config) => {
  if (config.params) {
    Object.keys(config.params).forEach(key => {
      if (typeof config.params[key] === 'string') {
        config.params[key] = config.params[key].trim();
      }
    });
  }
  
  if (config.url && config.url.includes('?')) {
    const [baseUrl, queryString] = config.url.split('?');
    const params = new URLSearchParams(queryString);
    let updated = false;
    params.forEach((value, key) => {
      const trimmed = value.trim();
      if (trimmed !== value) {
        params.set(key, trimmed);
        updated = true;
      }
    });
    if (updated) {
      config.url = `${baseUrl}?${params.toString()}`;
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});